import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Sparkles, ShieldCheck, Lock, CreditCard } from 'lucide-react';
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/uxFUMbp7rpyj5PEWokPKpa/heylloyd-image-1778600585408.png';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" style={{
    background: 'linear-gradient(160deg, #FFFFFF 0%, #FFF5F5 100%)'
  }} data-id="element-206">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-207">
        <div className="text-center mb-8" data-id="element-208">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-softGreen text-brand-accent border border-brand-verifiedGreen font-bold mb-6 uppercase tracking-wider text-[12px]" data-id="element-209">
            ⭐ +300 mujeres ya lo tienen
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-6 leading-tight" data-id="element-210">
            Tu cuerpo no está roto.
          </h1>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight" data-id="element-211">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-accent to-brand-terracotta" data-id="element-212">
              Solo nadie te dio el sistema correcto.
            </span>
          </h2>

          <div className="relative w-full max-w-sm mx-auto mb-8" data-id="element-213">
            <img src={LCP_IMAGE} alt="Megapack: Reset Digestivo y Emocional — Guía Holística para el Equilibrio Femenino, Cuerpo y Alma" className="w-full rounded-3xl shadow-lg" fetchPriority="high" loading="eager" width={512} height={768} decoding="async" sizes="(max-width: 768px) 80vw, 384px" style={{
            aspectRatio: '2/3'
          }} data-id="element-214" />
          </div>

          <p className="text-xl md:text-2xl text-brand-muted mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-215">
            Reducí la hinchazón, recuperá tu energía y calmá la ansiedad en 72
            horas.
          </p>

          <p className="text-lg text-brand-muted mb-10 max-w-2xl mx-auto" data-id="element-216">
            Sistema completo de reset digestivo y emocional. Sin dietas
            restrictivas. Sin gimnasio. Desde tu casa.
          </p>
        </div>

        <FadeIn delay={0.2} className="flex flex-col items-center" data-id="element-217">
          <Button href="https://librofy-store.myshopify.com/checkouts/cn/hWNC5X2P2PkCUJbS8YPpTCfx/es-ar?_r=AQAB1UPdc-8veqwkFNY9jRjuDbNWVeiM_7gIUxb_I2G_GIo&preview_theme_id=160306823389" size="xl" variant="terracotta" className="mb-6 group" data-id="element-218">
            🌿 QUIERO MI MEGAPACK AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-brand-muted mb-12" data-id="element-219">
            <div className="flex items-center gap-1.5" data-id="element-220">
              <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-221" /> Garantía 7
              días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-222">
              <Lock className="w-4 h-4 text-brand-accent" data-id="element-223" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-224">
              <CreditCard className="w-4 h-4 text-brand-accent" data-id="element-225" /> Mercado Pago
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-226">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-brand-card border border-brand-border p-6 rounded-2xl shadow-sm" data-id="element-227">
            <div className="flex flex-col items-center text-center gap-2" data-id="element-228">
              <Sparkles className="w-6 h-6 text-brand-accent" data-id="element-229" />
              <span className="font-medium text-sm" data-id="element-230">3 Tomos Completos</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-231">
              <span className="text-2xl" data-id="element-232">⚡</span>
              <span className="font-medium text-sm" data-id="element-233">Acceso en 5 min</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-234">
              <span className="text-2xl" data-id="element-235">🇦🇷</span>
              <span className="font-medium text-sm" data-id="element-236">Para Argentina</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-237">
              <span className="text-2xl" data-id="element-238">📱</span>
              <span className="font-medium text-sm" data-id="element-239">100% Digital</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}